<template>
  <div class="finance-container">
    <div class="page-header">
      <h2>财务管理</h2>
      <p>管理财务收支和账单记录</p>
    </div>
    
    <div class="finance-content">
      <el-card class="search-filter">
        <div class="card-content">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input placeholder="订单编号" v-model="searchParams.orderNo" clearable />
            </el-col>
            <el-col :span="6">
              <el-select placeholder="交易类型" v-model="searchParams.transactionType" clearable>
                <el-option label="收入" value="income" />
                <el-option label="支出" value="expense" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="searchParams.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="handleSearch">搜索</el-button>
              <el-button @click="handleReset" style="margin-left: 10px;">重置</el-button>
            </el-col>
          </el-row>
        </div>
      </el-card>
      
      <div class="stats-section">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-number">¥ 128,560.00</div>
                <div class="stat-label">本月收入</div>
              </div>
              <div class="stat-icon income-icon">
                <i class="el-icon-coin"></i>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-number">¥ 34,280.00</div>
                <div class="stat-label">本月支出</div>
              </div>
              <div class="stat-icon expense-icon">
                <i class="el-icon-money"></i>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-number">¥ 94,280.00</div>
                <div class="stat-label">本月利润</div>
              </div>
              <div class="stat-icon profit-icon">
                <i class="el-icon-success"></i>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-number">156</div>
                <div class="stat-label">交易笔数</div>
              </div>
              <div class="stat-icon count-icon">
                <i class="el-icon-document"></i>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      
      <div class="table-section">
        <el-card>
          <div slot="header" class="clearfix">
            <span>财务记录列表</span>
            <el-button type="primary" size="small" style="float: right;">导出报表</el-button>
          </div>
          <el-table :data="financeRecordsData" style="width: 100%">
            <el-table-column type="index" width="50" />
            <el-table-column prop="orderNo" label="订单编号" width="180" />
            <el-table-column prop="transactionType" label="交易类型" width="100">
              <template slot-scope="{row}">
                <el-tag :type="getTransactionTypeTag(row.transactionType)" size="small">
                  {{ getTransactionTypeName(row.transactionType) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="金额(¥)" width="120">
              <template slot-scope="scope">
                <span :class="scope.row.transactionType === 'expense' ? 'expense-amount' : 'income-amount'">
                  {{ scope.row.transactionType === 'expense' ? '-' : '+' }}{{ scope.row.amount.toFixed(2) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="transactionTime" label="交易时间" width="180" />
            <el-table-column prop="paymentMethod" label="支付方式" width="120" />
            <el-table-column prop="description" label="交易描述" width="200" />
            <el-table-column prop="status" label="交易状态" width="100">
              <template slot-scope="{row}">
                <el-tag :type="getTransactionStatusType(row.status)" size="small">
                  {{ getTransactionStatusName(row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
              <template>
                <el-button type="text" size="small">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination" style="margin-top: 20px;">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalRecords"
              :page-sizes="[10, 20, 50, 100]"
              :current-page="pagination.currentPage"
          :page-size="pagination.page_size"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Finance',
  data() {
    return {
      searchParams: {
        orderNo: '',
        transactionType: '',
        dateRange: []
      },
      pagination: {
        currentPage: 1,
        page_size: 10
      },
      totalRecords: 324,
      financeRecordsData: [
        {
          id: 1,
          orderNo: 'FIN-20231025-001',
          transactionType: 'income',
          amount: 25600.00,
          transactionTime: '2023-10-25 09:15:30',
          paymentMethod: '银行转账',
          description: '客户A月度服务费',
          status: 'completed'
        },
        {
          id: 2,
          orderNo: 'FIN-20231025-002',
          transactionType: 'expense',
          amount: 8500.00,
          transactionTime: '2023-10-25 10:30:15',
          paymentMethod: '银行转账',
          description: '设备采购费用',
          status: 'completed'
        },
        {
          id: 3,
          orderNo: 'FIN-20231025-003',
          transactionType: 'income',
          amount: 12800.00,
          transactionTime: '2023-10-25 11:45:20',
          paymentMethod: '支付宝',
          description: '客户B季度服务费',
          status: 'completed'
        },
        {
          id: 4,
          orderNo: 'FIN-20231025-004',
          transactionType: 'expense',
          amount: 3200.00,
          transactionTime: '2023-10-25 14:20:45',
          paymentMethod: '微信支付',
          description: '办公用品采购',
          status: 'completed'
        },
        {
          id: 5,
          orderNo: 'FIN-20231025-005',
          transactionType: 'income',
          amount: 18500.00,
          transactionTime: '2023-10-25 15:40:10',
          paymentMethod: '银行转账',
          description: '客户C项目预付款',
          status: 'pending'
        }
      ]
    }
  },
  methods: {
    // 搜索财务记录
    handleSearch() {
      this.pagination.currentPage = 1
      this.$message.success('搜索条件已应用')
    },
    
    // 重置搜索条件
    handleReset() {
      this.searchParams = {
        orderNo: '',
        transactionType: '',
        dateRange: []
      }
      this.pagination.currentPage = 1
      this.$message.info('搜索条件已重置')
    },
    
    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.page_size = size
    },
    
    // 当前页码变化
    handleCurrentChange(current) {
      this.pagination.currentPage = current
    },
    
    // 获取交易类型名称
    getTransactionTypeName(type) {
      return type === 'income' ? '收入' : '支出'
    },
    
    // 获取交易类型标签类型
    getTransactionTypeTag(type) {
      return type === 'income' ? 'success' : 'danger'
    },
    
    // 获取交易状态名称
    getTransactionStatusName(status) {
      const statusMap = {
        'pending': '处理中',
        'completed': '已完成',
        'failed': '失败'
      }
      return statusMap[status] || status
    },
    
    // 获取交易状态标签类型
    getTransactionStatusType(status) {
      const typeMap = {
        'pending': 'warning',
        'completed': 'success',
        'failed': 'danger'
      }
      return typeMap[status] || 'default'
    }
  }
}
</script>

<style scoped>
.finance-container {
  padding: 20px;
}

.page-header h2 {
  color: #303133;
  font-size: 24px;
  margin-bottom: 10px;
}

.page-header p {
  color: #606266;
  font-size: 14px;
  margin-bottom: 30px;
}

.search-filter {
  margin-bottom: 20px;
}

.stats-section {
  margin-bottom: 20px;
}

.stat-card {
  height: 120px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #909399;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

.income-icon {
  background-color: #67C23A;
}

.expense-icon {
  background-color: #F56C6C;
}

.profit-icon {
  background-color: #409EFF;
}

.count-icon {
  background-color: #909399;
}

.table-section {
  margin-bottom: 20px;
}

.expense-amount {
  color: #F56C6C;
}

.income-amount {
  color: #67C23A;
}

.pagination {
  display: flex;
  justify-content: flex-end;
}
</style>